import { PersonalDetailsFormValue } from '@checkout/util-models';
import {
  ContactMethod,
  CustomerDetails,
  CustomerEmailDetails,
  CustomerTelephoneDetails,
  DocumentSendMethod,
  removeNullValues,
} from '@domgen/dgx-fe-common';
import { formatFormAddressToCustomerAddress } from '@domgen/dgx-fe-forms/address';

export function formatPersonalDetailsFormValueToCustomerDetails(
  formValue: PersonalDetailsFormValue
): CustomerDetails | undefined {
  formValue = removeNullValues(formValue);

  if (!formValue.firstName || !formValue.lastName) {
    return undefined;
  }

  return {
    address: formatFormAddressToCustomerAddress(formValue.address),
    email: formatEmailDetails(formValue.emailAddress),
    firstName: formValue.firstName,
    initial: formValue.firstName.substring(0, 1),
    isOverrideAddress: formValue.address.isOverrideAddress,
    preferredContactMethod: formatPreferredContactMethod(formValue),
    sendMethod: formatDocumentSendMethod(formValue.emailAddress),
    surname: formValue.lastName,
    telephoneDetails: formatTelephoneDetails(formValue.telephoneNumber),
    title: formValue.titleId ?? undefined,
  };
}

export function formatCustomerDetailsToPersonalDetailsFormValue(
  personDetails?: CustomerDetails
): PersonalDetailsFormValue | undefined {
  if (!personDetails) {
    return undefined;
  }

  return {
    address: {
      ...personDetails.address,
      isOverrideAddress: personDetails.isOverrideAddress,
    },
    emailAddress: personDetails.email?.main ?? null,
    firstName: personDetails.firstName,
    lastName: personDetails.surname,
    telephoneNumber: personDetails.telephoneDetails?.home ?? null,
    titleId: personDetails.title ?? null,
  };
}

export function formatDocumentSendMethod(
  emailAddress: string | null
): DocumentSendMethod {
  if (emailAddress) {
    return DocumentSendMethod.Email;
  }
  return DocumentSendMethod.Post;
}

export function formatEmailDetails(
  emailAddress: string | null
): CustomerEmailDetails | undefined {
  if (!emailAddress) {
    return;
  }
  return {
    main: emailAddress,
  };
}

export function formatPreferredContactMethod(
  formValue: PersonalDetailsFormValue
): ContactMethod {
  if (formValue.emailAddress) {
    return ContactMethod.Email;
  }
  return ContactMethod.Post;
}

export function formatTelephoneDetails(
  telephoneNumber: string | null
): CustomerTelephoneDetails | undefined {
  if (!telephoneNumber) {
    return;
  }
  return {
    home: telephoneNumber,
    mobile: telephoneNumber,
  };
}
